export default function () {
    let inactivityTimeout;
    const popupWrapper = document.querySelector('.popup-home-wrapper');
    const closeButton = document.querySelector('.popup-home__close');

    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    let popupClosed = false;

    function openPopup() {
        if (popupClosed) {
            return;
        }

        document.body.classList.add('no-scroll');
        popupWrapper.classList.add('active');
    }

    function closePopup() {
        popupClosed = true;

        document.body.classList.remove('no-scroll');
        popupWrapper.classList.remove('active');

        clearTimeout(inactivityTimeout);
    }

    function startInactivityTimer() {
        if (popupClosed) {
            return;
        }

        clearTimeout(inactivityTimeout);

        inactivityTimeout = setTimeout(() => {
            openPopup();
        }, 40000);
    }

    function handleMouseLeave(event) {
        if (popupClosed || isMobile) {
            return;
        }

        if (event.clientY < 0
            || event.clientY > window.innerHeight
            || event.clientX < 0
            || event.clientX > window.innerWidth
        ) {
            openPopup();
        }
    }

    function handleVisibilityChange() {
        if (document.visibilityState === 'visible' && !popupWrapper.classList.contains('active') && !popupClosed) {
            openPopup();
        }
    }

    function handleTouchInteraction() {
        if (popupClosed) {
            return;
        }

        startInactivityTimer();
    }

    popupWrapper.addEventListener('click', (event) => {
        if (event.target === popupWrapper) {
            closePopup();
        }
    });

    closeButton.addEventListener('click', closePopup);

    if (!isMobile) {
        document.addEventListener('mouseleave', handleMouseLeave);
        document.addEventListener('mousemove', startInactivityTimer);
        document.addEventListener('keydown', startInactivityTimer);
    } else {
        document.addEventListener('touchstart', handleTouchInteraction);
        document.addEventListener('touchmove', handleTouchInteraction);
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);

    startInactivityTimer();
}

